export default __webpack_public_path__ + "static/media/197.c817ea9e.jpg";